import Request from "./request";

export default class CameraService {
  static async getList(data) {
    return new Promise((resolve, reject) => {
      Request.send({
        method: "POST",
        path: "/StationCamera/advanceUser/getList",
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve(result.data);
        } else {
          return reject();
        }
      });
    });
  }
  static async Create(data) {
    return new Promise((resolve, reject) => {
      Request.send({
        method: "POST",
        path: "/StationCamera/advanceUser/create",
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve(result.data);
        } else {
          return reject();
        }
      });
    });
  }
  static async Delete(data) {
    return new Promise((resolve, reject) => {
      Request.send({
        method: "POST",
        path: "/StationCamera/advanceUser/deleteCamera",
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve(result.data);
        } else {
          return reject();
        }
      });
    });
  }
  static async getDetail(data) {
    return new Promise((resolve, reject) => {
      Request.send({
        method: "POST",
        path: "/StationCamera/advanceUser/getDetail",
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve(result.data);
        } else {
          return reject();
        }
      });
    });
  }
  static async updateCamera(data) {
    return new Promise((resolve, reject) => {
      Request.send({
        method: "POST",
        path: "/StationCamera/advanceUser/updateCamera",
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve(result.data);
        } else {
          return reject();
        }
      });
    });
  }
  static async CreateConnection(data) {
    return new Promise((resolve, reject) => {
      Request.send({
        method: "POST",
        path: "/StationCameraConnection/advanceUser/create",
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve(result.data);
        } else {
          return reject();
        }
      });
    });
  }
  static async updateCameraConnection(data) {
    return new Promise((resolve, reject) => {
      Request.send({
        method: "POST",
        path: "/StationCameraConnection/advanceUser/updateCameraConnection",
        data: data,
      }).then((result = {}) => {
        const { statusCode } = result;
        if (statusCode === 200) {
          return resolve(result.data);
        } else {
          return reject();
        }
      });
    });
  }
}
